module.exports = __webpack_public_path__ + "fishing.93cfa30fdbb175c41abdf516cee5ff24.png";